export const getYesNoStatus = (status: boolean | undefined | null) => {
    if (status === false) {
        return 'Нет';
    }
    if (status === true) {
        return 'Да';
    }

    return null;
};
